import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Logout = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Logout' {...props}>
    <path fill='none' stroke='#231F20' strokeWidth='2' d='M13,9 L13,2 L1,2 L1,22 L13,22 L13,15 M22,12 L5,12 M17,7 L22,12 L17,17' />
  </StyledIcon>
);
